module.exports = __webpack_public_path__ + "static/img/hylogo.c0845fee.png";